import { Component, OnInit, Input, SimpleChanges, ViewChild } from '@angular/core';
import { LoggedLandingPageService } from 'src/app/core/services/logged-landing-page.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { OwlOptions } from 'ngx-owl-carousel-o';
declare var $: any;

@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss']
})
export class VideoComponent implements OnInit {

  @Input() whichSection;
  @Input() contentId;
  @Input() passRoute;
  video: [];
  isError: boolean = false;
  errorMessage: string;
  imgURL: any = environment.url;
  slider: any;
  currentUser: any;
  @Input() videoData;
  @ViewChild('owlCarousel', { static: false }) owlCarousel: any;
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    autoWidth: true,
    navSpeed: 500,
    navText: ['', ''],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 2
      },
      740: {
        items: 3
      },
      940: {
        items: 4
      },
      1199: {
        items: 4
      }
    },
    nav: true
  }
  constructor(
    private _authService: AuthService,
    private _router: Router) { }

  ngOnInit() {
    this.currentUser = this._authService.getCurrentUser();
  }
  // ngOnChanges(changes: SimpleChanges) {
  //   if (changes.videoData.currentValue.length > 2) {
  //     const _this = this;
  //     setTimeout(function(){
  //       _this.loadSlider();
  //     },500);
  //   }

  // }
  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.videoData && changes.videoData.currentValue.length > 0 && changes.videoData.currentValue.length < 5) {
      this.customOptions.responsive['1199'].items = changes.videoData.currentValue.length;
      this.customOptions.loop = false;
    }else if(changes && changes.videoData && changes.videoData.currentValue.length >= 5){
      this.customOptions.loop = true;
      this.customOptions.responsive['1199'].items = 4;
    }
    if(this.contentId && this.whichSection === 'video'){
      this.owlCarousel.to(this.contentId);
    }
  }

  disableLeftClick(event: MouseEvent): void {
    if (event.button === 0) {
      event.preventDefault(); // Prevent the default left-click behavior
    }
  }

  videoClick(id) {
    if (this._authService.isLoggednIn()) {
      if(this.passRoute){
        this._router.navigate(['/material-detail-page', id, 'public'], { queryParams: { whichRoute: 'dashboard', whichSection: 'video' } })
      } else {
        this._router.navigate(['/material-detail-page', id, 'public'])
      }
    }
    else {
      this._router.navigate(['/material-detail', id, 'public'])
    }
  }

  // slideNext() {
  //   this.slider.slick("slickNext");
  // }

  // slidePrevious() {
  //   this.slider.slick("slickPrev");
  // }

  // loadSlider() {
  //   this.slider = $(".data-slick-video").slick({
  //     centerMode: false,
  //     slidesToShow: 4,
  //     slidesToScroll: 3,
  //     autoplay: false,
  //     arrows: false,
  //     speed: 850,
  //     variableWidth: true,
  //     responsive: [
  //       {
  //         breakpoint: 1199,
  //         settings: {
  //           slidesToShow: 4,
  //           slidesToScroll: 3,
  //           infinite: true,
  //           dots: false,
  //           centerMode: false,
  //           centerPadding: '45px',
  //         }
  //       },
  //       {
  //         breakpoint: 991,
  //         settings: {
  //           slidesToShow: 1,
  //           slidesToScroll: 1,
  //           centerMode: false,
  //           centerPadding: '15px',
  //           speed: 500,
  //         }
  //       }
  //       // You can unslick at a given breakpoint now by adding:
  //       // settings: "unslick"
  //       // instead of a settings object
  //     ]
  //   });
  //   this.slider.on('wheel', (function(e) {
  //     e.preventDefault();

  //     if (e.originalEvent.deltaY < 0) {
  //       $(this).slick('slickNext');
  //     } else {
  //       $(this).slick('slickPrev');
  //     }
  //   }));
  // }
  // initializeSlider() {
  //   const _this = this;
  //   if (this.videoData && this.videoData.length > 4) {
  //     setTimeout(() => {

  //       _this.owlCarousel.el.nativeElement.onwheel = function (e) {
  //         e.preventDefault();
  //         if (e.deltaY < 0) {
  //           _this.owlCarousel.next();
  //         } else {
  //           _this.owlCarousel.prev();
  //         }
  //         e.preventDefault();
  //       };
  //     }, 100);
  //   }

  // }
}
